Ext.define('SA.CrosstabHeaderLabelTrimmer', {
    constructor({top} = {}) {
        this.maxLines = SA.CrosstabHeaderCell.getMaxLines(top);

        this.cache = new Map();
        this.lineCounter = new SA.LineCounter({cls: SA.CrosstabHeaderCell.getCls(top)});
    },

    performTrim(untrimmed) {
        var exceedsMaxLines = text => this.lineCounter.count(text) > this.maxLines,
            trimmed, tokens;

        if (!exceedsMaxLines(untrimmed)) {
            return untrimmed;
        }

        untrimmed = untrimmed.replace(/\//g, '/\u200B'); 
        untrimmed = untrimmed.replace(/\(/g, '\u200B('); 

        trimmed = '';
        tokens = untrimmed.split(/([\-\/]\w+|[\(\:]\S+|\s+|\|)/);

        while (tokens.length > 0) {
            let provisional = tokens.pop() + trimmed;

            if (exceedsMaxLines('…' + provisional)) {
                break;
            }

            trimmed = provisional;
        }

        return '…' + trimmed.trim().replace(/^(\|\s*|\-\s+)/, '');
    },

    trim(untrimmed) {
        if (!this.cache.has(untrimmed)) {
            let trimmed = this.performTrim(untrimmed);

            this.cache.set(untrimmed, trimmed);
        }

        return this.cache.get(untrimmed);
    }
});